<template>
    <div class="container-fluid feature pt-5">
      <div class="container pt-5">
        <div class="row g-5">
          <div class="col-lg-6 align-self-center mb-md-5 pb-md-5" data-aos="fade-right">
            <h1 class="text-white mb-4">NOTRE PROCESSUS COMPLET</h1>
            <p class="text-light mb-4">Prise de contact et cadrage – Sourcing des candidats – Présélection – Tests – Entretiens – Prise de références – Rapport succinct contenant un short-list final.</p>
            
            <div class="process-list">
              <div class="process-item" v-for="(item, index) in processItems" :key="index">
                <div class="icon-box">
                  <i :class="item.icon"></i>
                </div>
                <div class="process-content">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 align-self-center mb-md-5 pb-md-5" data-aos="fade-left">
            <div class="services-section">
              <h2 class="text-white mb-4">NOS SERVICES</h2>
              <div class="service-box" v-for="(service, index) in services" :key="index">
                <i :class="service.icon"></i>
                <h3>{{ service.title }}</h3>
                <p>{{ service.description }}</p>
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        processItems: [
          { 
            icon: 'fa fa-handshake',
            title: 'Prise de contact et cadrage',
            text: 'Entretien physique ou virtuel pour cerner le profil recherché et la culture de votre entreprise.'
          },
          {
            icon: 'fa fa-search',
            title: 'Sourcing des candidats',
            text: 'Recherche via notre vivier interne, jobs boards, réseaux sociaux et approche directe.'
          },
          {
            icon: 'fa fa-filter',
            title: 'Présélection et Tests',
            text: 'Administration de tests métiers et psychotechniques selon les domaines.'
          },
          {
            icon: 'fa fa-comments',
            title: 'Entretiens et Références',
            text: 'Entretiens en présentiel ou à distance et vérification systématique des références.'
          }
        ],
        services: [
          {
            icon: 'fa fa-users',
            title: 'CANDIDATS',
            description: 'Accompagnement vers des employeurs de choix et des postes adaptés.'
          },
          {
            icon: 'fa fa-file-alt',
            title: 'MISE A DISPOSITION DE CV',
            description: 'CV de candidats avec tests psychotechniques optionnels.'
          },
          {
            icon: 'fa fa-search-plus',
            title: 'CHASSE DE TETE',
            description: 'Recherche ciblée des meilleurs talents pour votre entreprise.'
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .feature {
    background-color: #29b3cd;
    background-image: linear-gradient(#29b3cd, #bc6a3c), url('../assets/img/bg-hero.png');
    background-size: cover;
    background-position: center;
    color: white;
    padding: 4rem 0;
  }
  
  .process-list .process-item {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    transition: all 0.3s ease;
  }
  
  .process-item:hover {
    transform: translateX(10px);
    background: rgba(255, 255, 255, 0.2);
  }
  
  .process-item .icon-box {
    background-color: #e95d16;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }
  
  .process-item .icon-box i {
    color: white;
    font-size: 1.2rem;
  }
  
  .process-content h3 {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  .process-content p {
    font-size: 0.9rem;
    opacity: 0.9;
    margin: 0;
  }
  
  .service-box {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 1.5rem;
    margin-bottom: 1rem;
    transition: all 0.3s ease;
  }
  
  .service-box:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.2);
  }
  
  .service-box i {
    font-size: 2rem;
    color: #bc6a3c;
    margin-bottom: 1rem;
  }
  
  .service-box h3 {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  .service-box p {
    font-size: 0.9rem;
    opacity: 0.9;
    margin: 0;
  }
  
  .img-fluid.hero {
    max-width: 100%;
    height: auto;
    animation: float 6s ease-in-out infinite;
  }
  
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }

  @media (max-width: 575px) {
    .feature { padding: 2rem 0; }
    .feature h1 { font-size: 1.4rem; }
    .feature h2 { font-size: 1.3rem; }
    .process-list .process-item { padding: 1rem; }
    .service-box { padding: 1rem; }
  }
  </style>